import AgriculturalControllers from "../../../../pages-v1/AgriculturalControllers";

export const Page = AgriculturalControllers;
